// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div id="address-validation" />
      <h1>Address Validation</h1>
      <h2 id="september-26%2C-2018">September 26, 2018</h2>
      <p>Create Address Validation API</p>
      <ul>
      <li>The ‘validate’ API accepts a structured JSON address object (broken down by street/city/state/zip/etc), and returns a result indicating whether the address is valid, and if so includes a canonicalized address and geocoding information (lat/long) for the address.</li>
      </ul>
      <hr />
      <div id="veteran-confirmation" />
      <h1>Veteran Confirmation</h1>
      <h2 id="january-13%2C-2020">January 13, 2020</h2>
      <p>Launched Veteran Confirmation API with a status endpoint</p>
      <ul>
      <li><code>/status</code>: Allows third-parties to request confirmation from the VA of an individual's Veteran status after providing a valid API key and identifying attributes for the individual.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3676">View code change(s)</a></p>
      <hr />
      <div id="veteran-verification" />
      <h1>Veteran Verification</h1>
      <h2 id="november-8%2C-2018">November 8, 2018</h2>
      <p>Launched the Disability Rating and Veteran Status endpoints</p>
      <ul>
      <li><code>/disability_rating</code>: Given an authenticated user, this created an endpoint that returns a Veteran's disability rating from VA</li>
      <li><code>/status</code>: Allows third-parties to request confirmation from the VA of an individual's Veteran status after receiving authorization to do so using an Open ID Connect flow.</li>
      </ul>
      <hr />
      <h2 id="june-11%2C-2018">June 11, 2018</h2>
      <p>Launched the Service History endpoint</p>
      <ul>
      <li><code>/service_history</code>: Given an authenticated user, this created an endpoint that returns a Veteran's service history from VA</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
